import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import OwnerShell from './OwnerShell';
import CoralHeader from '../dashboard/CoralHeader';

const GHOST_PILL =
  'w-full rounded-full bg-white border-2 border-hairline text-body-grey font-grotesk font-bold text-[13px] py-3 px-4 text-center transition-colors hover:border-coral hover:text-coral';

// MORE tab of owner mode (route /shops/owner/more) — the mockup's owner bar
// only sketched 3 tabs (COUNTER/STATS/SETUP); this 4th tab is where the
// existing till-kit/member-cards/assisted-signup pages and log out get a
// home, mirroring the customer MORE pattern (white-card button list) rather
// than inventing a new layout for them.
export default function OwnerMorePanel() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  return (
    <OwnerShell
      active="more"
      header={
        <CoralHeader
          eyebrow="BACK OFFICE"
          title="Shop tools"
          statusLabel="MORE"
        />
      }
    >
      <div className="flex flex-col gap-3.5">
        <div className="bg-white rounded-[10px] p-[18px] flex flex-col gap-2.5">
          <button onClick={() => navigate('/')} className={GHOST_PILL}>
            Back to my card
          </button>
          <button onClick={() => navigate('/shops/till-kit')} className={GHOST_PILL}>
            Till kit
          </button>
          <button onClick={() => navigate('/shops/member-cards')} className={GHOST_PILL}>
            Member cards
          </button>
          <button onClick={() => navigate('/shops/assist')} className={GHOST_PILL}>
            Assisted signup
          </button>
        </div>

        <button
          onClick={logout}
          className="w-full rounded-full border-2 border-error text-error bg-transparent font-grotesk font-bold text-[13px] py-3 px-4"
        >
          Log out
        </button>
      </div>
    </OwnerShell>
  );
}
